/*
  Do not edit directly
  Generated on Wed, 03 Jun 2020 10:45:44 GMT
*/

const lnTu = {
  color: {
    palette: {
      black: "#000000",
      blue60: "#00A9CF",
      brand1: "#000000",
      brand1Highlight: "#3D4042",
      brand2: "#000000",
      brand2Highlight: "#000000",
      green60: "#218234",
      grey100: "#0D0D0D",
      grey90: "#262626",
      grey80: "#404040",
      grey70: "#595959",
      grey60: "#737373",
      grey50: "#8C8C8C",
      grey40: "#A6A6A6",
      grey30: "#BFBFBF",
      grey20: "#D8D8D8",
      grey10: "#F2F2F2",
      orange60: "#F06C00",
      orange70: "#E55000",
      red: "#E53212",
      aqua: "#00A9CF",
      green: "#218234",
      yellow: "#FFD000",
      blue: "#00A9CF",
      red60: "#E53212",
      white: "#FFFFFF",
      yellow60: "#FFD000",
      black50: "#262626",
      black60: "#000000",
      blackLight: "#262626",
      pink30: "#F8BFDC",
      pink40: "#F27FBA",
      pink50: "#EC4098",
      pink60: "#E50075",
      red30: "#F8CCC4",
      red40: "#F29888",
      red50: "#EC664E",
      yellow30: "#FFF3BF",
      yellow40: "#FFE77F",
      yellow50: "#FFDC40"
    },
    monochrome: {
      white: "#FFFFFF",
      lighter: "#F2F2F2",
      light: "#D8D8D8",
      medium: "#737373",
      dark: "#404040",
      darker: "#262626",
      greyVLight: "#F2F2F2",
      greyLight: "#D8D8D8",
      grey: "#8C8C8C",
      greyDark: "#404040",
      greyDarker: "#262626",
      black: "#000000"
    },
    scheme: {light: "#000000", dark: "#FFFFFF", brand1: "#FFFFFF", brand2: "#FFFFFF"},
    semantic: {
      success: "#218234",
      info: "#00A9CF",
      warning: "#FFD000",
      error: "#E53212",
      successBase: "#FFFFFF",
      infoBase: "#000000",
      warningBase: "#404040",
      errorBase: "#FFFFFF"
    }
  },
  mode: {
    dark: {
      background: "#262626",
      base: "#F2F2F2",
      baseInverse: "#404040",
      border: "#404040",
      footerBackground: "#FFFFFF",
      footerText: "#404040",
      foreground: "#262626",
      headerBackground: "#262626",
      headerText: "#F2F2F2",
      highlight: "#FFFFFF",
      highlightInverse: "#000000"
    },
    default: {
      background: "#F2F2F2",
      base: "#404040",
      baseInverse: "#404040",
      border: "#D8D8D8",
      footerBackground: "#262626",
      footerText: "#F2F2F2",
      foreground: "#FFFFFF",
      headerBackground: "#FFFFFF",
      headerText: "#404040",
      highlight: "#000000",
      highlightInverse: "#000000"
    }
  },
  surface: {
    light: {background: "#F2F2F2", base: "#404040", border: "#D8D8D8", highlight: "#000000"},
    white: {background: "#FFFFFF", base: "#404040", border: "#D8D8D8", highlight: "#000000"},
    dark: {background: "#262626", base: "#F2F2F2", border: "#404040", highlight: "#FFFFFF"},
    grey: {background: "#262626", base: "#F2F2F2", border: "#404040", highlight: "#000000"}
  },
  modifier: {
    border: {width: "1px", widthLarge: "2px", radius: "2px"},
    button: {border: "2px", textTransform: "uppercase"},
    focusRing: {focusWidth: "3px", color: "#00A9CF"},
    footer: {background: "#404040", text: "#FFFFFF"},
    header: {background: "#FFFFFF"},
    globalBar: {height: "36px"},
    transition: {duration: "0.2s", durationLong: "0.4s", timingFunction: "ease-out"}
  },
  opacity: {default: {"": "0.7"}, light: {"": "0.15"}, disabled: {"": "0.35"}, background: {"": "0.08"}},
  overlay: {color: {"": "#000000"}, opacity: {"": "0.7"}},
  space: {
    baseline: {grid: 8, condensed: 4},
    fixedWidth: {extraSmall: 800, small: 1280, medium: 1440, large: 1800},
    size: {small: 24, medium: 48, large: 80},
    spacing: {default: 8, small: 8, medium: 16, large: 24, extraLarge: 32},
    breakpoints: {extraExtraSmall: 480, extraSmall: 600, small: 720, medium: 960, large: 1200, extraLarge: 1400, extraExtraLarge: 1800}
  },
  typography: {
    base: {fontFamily: "'Tu', Arial, Helvetica, sans-serif", font: "Tu", fallback: "Arial", letterform: "sans-serif"},
    brand: {fontFamily: "'Tu', Arial, Helvetica, sans-serif", font: "Tu", letterform: "sans-serif", fallback: "Arial"},
    monospace: {
      fontFamily: "Consolas, \"Andale Mono WT\", \"Andale Mono\", \"Lucida Console\", \"Lucida Sans Typewriter\", \"DejaVu Sans Mono\", \"Bitstream Vera Sans Mono\", \"Liberation Mono\", \"Nimbus Mono L\", Monaco, \"Courier New\", Courier, monospace"
    },
    system: {
      fontFamily: "system, -apple-system, \".SFNSText-Regular\", \"San Francisco\", \"Roboto\", \"Segoe UI\", \"Helvetica Neue\", \"Lucida Grande\", sans-serif"
    },
    fontSize: {root: 16, default: 16},
    fontWeight: {light: 300, regular: 400, medium: 500, semiBold: 600, bold: 700, extraBold: 800, black: 900}
  },
  fontStack: {
    display7: {fontSize: 62, lineHeight: 76, fontWeight: 700, fontFamily: "'Tu', Arial, Helvetica, sans-serif"},
    display6: {fontSize: 50, lineHeight: 62, fontWeight: 700, fontFamily: "'Tu', Arial, Helvetica, sans-serif"},
    display5: {fontSize: 40, lineHeight: 50, fontWeight: 700, fontFamily: "'Tu', Arial, Helvetica, sans-serif"},
    display4: {fontSize: 32, lineHeight: 40, fontWeight: 700, fontFamily: "'Tu', Arial, Helvetica, sans-serif"},
    display3: {fontSize: 26, lineHeight: 32, fontWeight: 700, fontFamily: "'Tu', Arial, Helvetica, sans-serif"},
    display2: {fontSize: 22, lineHeight: 26, fontWeight: 700, fontFamily: "'Tu', Arial, Helvetica, sans-serif"},
    display1: {fontSize: 20, lineHeight: 26, fontWeight: 700, fontFamily: "'Tu', Arial, Helvetica, sans-serif"},
    label: {fontSize: 18, lineHeight: 24, fontWeight: 700, fontFamily: "'Tu', Arial, Helvetica, sans-serif"},
    body2: {fontSize: 18, lineHeight: 26, fontWeight: 400, fontFamily: "'Tu', Arial, Helvetica, sans-serif"},
    body1: {fontSize: 16, lineHeight: 24, fontWeight: 400, fontFamily: "'Tu', Arial, Helvetica, sans-serif"},
    caption: {fontSize: 14, lineHeight: 20, fontWeight: 400, fontFamily: "'Tu', Arial, Helvetica, sans-serif"},
    button: {fontSize: 18, lineHeight: 20, fontWeight: 700, fontFamily: "'Tu', Arial, Helvetica, sans-serif"}
  },
  border: {width: {small: "1px", default: "2px", large: "2px"}, radius: {default: "0"}}
};

// Aliases 
export const lnTuColor = {
  aqua: "#00A9CF",
  black: "#000000",
  black50: "#262626",
  black60: "#000000",
  blackLight: "#262626",
  blue: "#00A9CF",
  blue60: "#00A9CF",
  brand1: "#000000",
  brand1Highlight: "#3D4042",
  brand2: "#000000",
  brand2Highlight: "#000000",
  green: "#218234",
  green60: "#218234",
  grey10: "#F2F2F2",
  grey100: "#0D0D0D",
  grey20: "#D8D8D8",
  grey30: "#BFBFBF",
  grey40: "#A6A6A6",
  grey50: "#8C8C8C",
  grey60: "#737373",
  grey70: "#595959",
  grey80: "#404040",
  grey90: "#262626",
  orange60: "#F06C00",
  orange70: "#E55000",
  pink30: "#F8BFDC",
  pink40: "#F27FBA",
  pink50: "#EC4098",
  pink60: "#E50075",
  red: "#E53212",
  red30: "#F8CCC4",
  red40: "#F29888",
  red50: "#EC664E",
  red60: "#E53212",
  white: "#FFFFFF",
  yellow: "#FFD000",
  yellow30: "#FFF3BF",
  yellow40: "#FFE77F",
  yellow50: "#FFDC40",
  yellow60: "#FFD000"
};
export const lnTuMonochrome = ["#FFFFFF", "#F2F2F2", "#D8D8D8", "#737373", "#404040", "#262626", "#F2F2F2", "#D8D8D8", "#8C8C8C", "#404040", "#262626", "#000000"];
export const lnTuFont = {base: "'Tu', Arial, Helvetica, sans-serif", brand: "'Tu', Arial, Helvetica, sans-serif"};
export const lnTuFontSize = {default: 16, scale: [14, 16, 18, 20, 22, 26, 32, 40, 50, 62]};
export const lnTuFontWeight = {light: 300, regular: 400, medium: 500, semiBold: 600, bold: 700, extraBold: 800, black: 900};
export const lnTuSpace = {base: 8, scale: [8, 16, 24, 32]};
export const lnTuSize = {small: 24, medium: 48, large: 80};
export const lnTuBaseline = {grid: 8, condensed: 4};
export const lnTuBreakpoint = {
  bp: {extraExtraSmall: 480, extraSmall: 600, small: 720, medium: 960, large: 1200, extraLarge: 1400, extraExtraLarge: 1800},
  scale: [480, 600, 720, 960, 1200, 1400, 1800]
};
export const lnTuBorder = {width: {small: "1px", default: "2px", large: "2px"}, radius: {default: "0"}};
export const lnTuTransition = undefined;
export default lnTu
